export default __webpack_public_path__ + "static/media/sad_icon.699c7294.svg";